import type { ReactNode } from "react";
import { Link, type LinkProps } from "react-router";
import { cn } from "@/service/classname.ts";

type IconLinkProps = Omit<LinkProps, "children"> & {
  label: string;
  icon: ReactNode;
  size?: "sm";
};

export const IconLink = ({
  label,
  icon,
  className,
  theme = "text",
  size,
  ...rest
}: IconLinkProps) => {
  return (
    <Link
      {...rest}
      theme={theme}
      className={cn("Button", className)}
      data-size={size}
    >
      {icon}
      <div className="Tooltip">{label}</div>
    </Link>
  );
};
